import { addDaysToYmd, studioTodayYmd } from "@/lib/utils/date/studio-clock";

const TEACHER_CALENDAR_WINDOW_DAYS = 90;
const ADMIN_CALENDAR_FUTURE_DAYS = 90;

/** Teacher portal: confirmed lessons in a ±90 day window around today. */
export function getTeacherPrivateLessonsCalendarRange(): {
  start: string;
  end: string;
} {
  const today = studioTodayYmd();
  return {
    start: addDaysToYmd(today, -TEACHER_CALENDAR_WINDOW_DAYS),
    end: addDaysToYmd(today, TEACHER_CALENDAR_WINDOW_DAYS),
  };
}

/** Admin/staff: upcoming private lessons for the next 90 days. */
export function getAdminPrivateLessonsCalendarRange(): {
  start: string;
  end: string;
} {
  const today = studioTodayYmd();
  return {
    start: today,
    end: addDaysToYmd(today, ADMIN_CALENDAR_FUTURE_DAYS),
  };
}
